import type { ChiTietPhieuNhapKho, PhieuNhapKhoAccountData, PhieuNhapKhoAmount } from '@/types/schemas';
import { roundNumber } from '@/lib/formatUtils';

type RowUpdateValue = unknown;
type DetailLookupValue = {
  thue_suat?: PhieuNhapKhoAmount;
  tk_khcp_data?: PhieuNhapKhoAccountData | null;
  dvt_nl_data?: { uuid?: string } | null;
  dvt_data?: { uuid?: string } | null;
};

type TotalRow = {
  so_luong?: unknown;
  tien_nt?: unknown;
};

export const handleUpdateRowFields = (row: ChiTietPhieuNhapKho, field: string, newValue: RowUpdateValue) => {
  const lookupValue = newValue as DetailLookupValue | null;

  if (field === 'so_luong' || field === 'gia_nt' || field === 'tl_ck' || field === 'ma_thue_data') {
    const so_luong = roundNumber(field === 'so_luong' ? Number(newValue) || 0 : row.so_luong, 6);
    const gia_nt = field === 'gia_nt' ? newValue : row.gia_nt;
    const tl_ck = field === 'tl_ck' ? newValue : row.tl_ck;
    const thue_suat = field === 'ma_thue_data' ? lookupValue?.thue_suat || 0 : row.ma_thue_data?.thue_suat || 0;

    const tien_nt = Round((Number(so_luong) || 0) * (Number(gia_nt) || 0));
    const ck_nt = Round((tien_nt * (Number(tl_ck) || 0)) / 100);
    const thue_nt = Round((tien_nt * (Number(thue_suat) || 0)) / 100);

    return { tien_nt, ck_nt, thue_nt };
  }

  if (field === 'ma_vt_data') {
    return {
      tk_vt_data: lookupValue?.tk_khcp_data || null,
      dvt: lookupValue?.dvt_nl_data?.uuid || lookupValue?.dvt_data?.uuid || row.dvt
    };
  }

  return {};
};

export const calculateMoney = (gia_nt: unknown, so_luong: unknown): number => {
  const gia = roundNumber(Number(gia_nt) || 0, 6);
  const sl = roundNumber(Number(so_luong) || 0, 6);
  return roundNumber(gia * sl, 6);
};

export const calculateTotals = (detailRows: TotalRow[]) => {
  const so_luong = roundNumber(
    detailRows.reduce((acc, row) => acc + Number(row.so_luong || 0), 0),
    6
  );
  const tong_tien = detailRows.reduce((acc, row) => acc + Number(row.tien_nt || 0), 0);
  const t_so_luong = so_luong;
  const t_tien_nt = roundNumber(tong_tien, 6);

  return {
    t_so_luong,
    t_tien_nt,
    t_tien: t_tien_nt
  };
};

const Round = (num: number): number => {
  return roundNumber(num, 6);
};
